import { createUseStyles } from 'react-jss'
import breakpoints from './breakpoints'

const useContainerStyles = createUseStyles({
    container: {
        width: '100%',
        maxWidth: '1075px',
        margin: '0 auto',
        padding: '0.625rem',
        [`@media (min-width: ${breakpoints.Desktop}px)`]: {
            '&': {
                padding: 0,
            },
        },
    },
})

export { useContainerStyles }
